import {createReducer} from '../../base/fsa/createReducer';
import {initialDebugState} from './state';
import {addUARTMessageAction, clearUARTMessagesAction} from './actions';

export const debugReducer = createReducer(initialDebugState, handle => [
    handle(addUARTMessageAction, (state, action) => {
        const uartMessageList = [{id: Math.random(), ...action.payload}, ...state.uartMessageList];
        while (uartMessageList.length > 500) {
            uartMessageList.pop();
        }

        return {
            ...state,
            uartMessageList,
        };
    }),
    handle(clearUARTMessagesAction, state => {
        return {
            ...state,
            uartMessageList: [],
        };
    }),
]);
